//import { getIcons } from "_helpers";
import { LogsTableList } from ".";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { diagnosticLoggerActions } from "_store";
import { ReturnButton, SidePanel } from "_components";
import { CustomAutocomplete } from "_components/CustomAutocomplete";
import { useParams } from "react-router-dom";

export { DiagnosticLoggerList };

/**
 * Composant d'affichage de la page DiagnosticLogger
 * Contient le tableau listant les données récupérées
 * @returns 
 */
function DiagnosticLoggerList() {
    const dispatch = useDispatch();
    const { busVin } = useParams();

    const vins = useSelector(state => state.diagnosticLogger?.vins);
    const [selectedVin, setSelectedVin] = useState(null)
    
    useEffect(() => {
        if(!vins){
            dispatch(diagnosticLoggerActions.getVins());
        }
    }, [vins, dispatch]);

    // Si un paramètre busVin est présent, essayer de préremplir l'autocomplete
    useEffect(() => {
        if (!busVin) return;

        if (vins && vins.length) {
            const match = vins.find(opt => {
                if (!opt) return false;
                if (typeof opt === "string") return opt === busVin;
                if (typeof opt === "object") {
                    // tester quelques clés possibles (adapter si nécessaire)
                    return [ "vin", "value", "id", "label" ].some(k => opt[k] === busVin);
                }
                return false;
            });
            setSelectedVin(match ?? busVin);
        } else {
            // pas encore de liste — garder la chaîne pour informer LogsTableList
            setSelectedVin(busVin);
        }
    }, [busVin, vins]);

    return (
        <div>
            <SidePanel />
            <ReturnButton />
            {/* Conteneur global */}
            <div className="custom-table-container flex flex-col">                
                {/* Ligne avec champ VIN aligné à droite */}
                <div className="flex justify-end">
                    <div className="w-1/3 py-2 mb-2">
                        <CustomAutocomplete
                            name="vin"
                            label="Veuillez sélectionner un Numéro VIN"
                            options={vins ?? []}
                            noOptionsText="Aucune correspondance"
                            onInputChange={() => false}
                            onChange={(val) => setSelectedVin(val)}
                            onClear={() => setSelectedVin(null)}
                            value={selectedVin}
                        />   
                    </div>
                </div>
                {/* Tableau */}
                <div className='w-full min-h-[45vh]'>
                    <LogsTableList vin={selectedVin}/>  
                </div>
            </div>
        </div>       
    );
}